/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect } from "react";
import { Box, Flex } from "rebass/styled-components";

import { layout } from "../../../constants/constants";
import { UiStateContext } from "../../contexts/ui-state/UiStateContext";
import { NavColumn } from "../../hooks/column-end/useColumnEnd";
import useBreakpoint from "../../hooks/use-breakpoint/useBreakpoint";
import { IconPack } from "../../models/app-data-model";
import NavMenuColumn from "../nav-menu-column/nav-menu-column";
import "./secondary-nav.scss";

export type SecondaryNavProps = {
  columns: NavColumn[];
  isOutsideClickHandlerEnabled?: boolean;
  iconPack?: IconPack[];
};

const SecondaryNav: React.FC<SecondaryNavProps> = ({ columns, isOutsideClickHandlerEnabled, iconPack }: SecondaryNavProps) => {
  const columnRenderings = columns.map((c, index) => <NavMenuColumn key={index} navContent={c.content} iconPack={iconPack} />);

  return (
    <div id="secondary-nav-container" className="secondary-nav-container">
      <Box width="100%" className="secondary-nav" id="secondary-nav">
        <Flex className="secondary-nav-content" width={layout.pageWidth} mx="auto" px={layout.pagePaddingX}>
          {columnRenderings}
        </Flex>
      </Box>
    </div>
  );
};

export default SecondaryNav;
